import { MouseEvent, useState } from 'react'
import {
  useDeleteInboxNotification,
  useMarkInboxNotificationAsRead,
} from '@/app/core/providers/UserNotificationProvider'

/**
 * A hook that provides shared state and actions for notification menus
 * @param notificationId - The ID of the notification
 * @returns An object containing the menu state and action handlers
 */
const useNotificationMenu = (
  notificationId: string
): {
  isHovered: boolean
  isMenuOpened: boolean
  setIsMenuOpened: (isOpen: boolean) => void
  onMarkAsRead: (e: MouseEvent<HTMLDivElement>) => void
  onDelete: (e: MouseEvent<HTMLDivElement>) => void
  onMouseEnter: () => void
  onMouseLeave: () => void
} => {
  const [isHovered, setIsHovered] = useState(false)
  const [isMenuOpened, setIsMenuOpened] = useState(false)

  const markInboxNotificationAsRead = useMarkInboxNotificationAsRead()
  const deleteInboxNotification = useDeleteInboxNotification()
  const onMarkAsRead = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    markInboxNotificationAsRead(notificationId)
    setIsMenuOpened(false)
  }

  const onDelete = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    deleteInboxNotification(notificationId)
    setIsMenuOpened(false)
  }

  const onMouseEnter = () => setIsHovered(true)
  const onMouseLeave = () => setIsHovered(false)

  return {
    isHovered,
    isMenuOpened,
    setIsMenuOpened,
    onMarkAsRead,
    onDelete,
    onMouseEnter,
    onMouseLeave,
  }
}

export default useNotificationMenu
